module.exports = __webpack_public_path__ + "img/krabi.1271a76b.jpg";